"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceStringPlaceholder = exports.getDatesBetween = exports.formatDate = exports.fixMonth = exports.default = exports.checkInput = exports.DateRangeForm = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _formik = require("formik");
var _moment = _interopRequireDefault(require("moment"));
require("core-js/features/array/flat");
var _SessionHandler = _interopRequireWildcard(require("../../../utils/SessionHandler"));
var _dateValidation = require("./date-validation");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
_moment.default.locale('de');
var BASE_CLASS = 'ConsumptionVis-DateRange';

/*
 * format date for usage in date-picker
 * @param {string} property - property to look at. returns undefined if not found
 * @param {object} obj - object with property
 */
var fixMonth = exports.fixMonth = function fixMonth(property) {
  if (Array.isArray(property)) {
    var clone = Array.isArray(property) && (0, _toConsumableArray2.default)(property);
    clone[1] -= 1;
    return clone;
  }
  return false;
};

/**
 * format date for usage in date-picker
 * @param {string} fixedDate - result from fixedMonth
 * @returns {Date} - date to use
 */
var formatDate = exports.formatDate = function formatDate(fixedDate) {
  return (0, _moment.default)(fixedDate).toDate();
};

/**
 * createMeasurementsList - returns data start date
 * @param {object} selectedDeviceByDateRange - deviceData for date range
 * @returns {date} - date as UTC in ms
 */
var createMeasurementsList = function createMeasurementsList(selectedDeviceByDateRange) {
  var data = selectedDeviceByDateRange.length > 1 ? selectedDeviceByDateRange.map(function (x) {
    return (0, _moment.default)(fixMonth(x.startTime)).valueOf();
  }) : (0, _moment.default)(fixMonth(selectedDeviceByDateRange[0] && selectedDeviceByDateRange[0].startTime)).valueOf();
  return data;
};

/**
 * checks current state of date field
 * @param {boolean} error - error flag for field
 * @param {boolean} touched - control flag if field already touched
 * @returns {enum} InputState - ERROR or default NONE
 */
var checkInput = exports.checkInput = function checkInput(error, touched) {
  if (touched && error) {
    return _reactSharedUiNext.InputState.ERROR;
  }
  return _reactSharedUiNext.InputState.NONE;
};

/**
 * replace placeholders with dynamic values
 * @param {string} orgString - string with placeholder
 * @param {array} values - list of values to replace placeholder
 * @returns {string} newString - returns orgstring with values
 */
var replaceStringPlaceholder = exports.replaceStringPlaceholder = function replaceStringPlaceholder(orgString, values) {
  var placeholder = '%%placeholder%%';
  var newString = values.length > 1 ? values.map(function (item) {
    values.shift();
    return replaceStringPlaceholder(orgString.replace(placeholder, item), values);
  })[0] : orgString.replace(placeholder, values);
  return newString;
};
var getDatesBetween = exports.getDatesBetween = function getDatesBetween(startDate, endDate) {
  var dates = [];
  // Strip hours minutes seconds etc.
  var currentDate = (0, _moment.default)(startDate).toDate();
  while (currentDate < endDate) {
    dates.push(currentDate);
    currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 1 // Will increase month if over range
    );
  }
  dates.shift();
  return dates;
};

/* eslint-disable react/prop-types */
// not possible because propTypes not recognized after assignment
var DateRangeForm = exports.DateRangeForm = function DateRangeForm(props) {
  return /*#__PURE__*/_react.default.createElement(_formik.Form, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-6 col-xs-12",
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.DatePicker, {
    disabled: props.orgProps.deviceDataProcceding,
    id: props.orgProps.dateFrom.id,
    locale: "de",
    daysLongLocalized: _moment.default.weekdays(),
    daysShortLocalized: _moment.default.weekdaysMin(),
    monthsLocalized: _moment.default.months(),
    name: props.orgProps.dateFrom.id,
    qaId: "qa-".concat(props.orgProps.dateFrom.id),
    label: props.orgProps.dateFrom.label,
    disabledDays: props.getMeterDateRange(),
    initialShownMonth: props.formikProps.values.fromDate.date,
    showOverlay: props.orgState.dateFromIsOpen && !props.orgProps.deviceDataProcceding,
    onBlur: function onBlur() {
      return props.handleBlur('from');
    },
    onFocus: function onFocus() {
      return props.setState({
        dateFromIsOpen: true
      });
    },
    onClick: function onClick() {
      return props.setState({
        dateFromIsOpen: true
      });
    },
    onChange: function onChange(date) {
      return props.handleChange(date, 'from', props.formikProps);
    },
    value: props.formikProps.values.fromDate,
    useNative: props.orgProps.isMobile || props.orgProps.isTablet,
    inputState: checkInput(props.formikProps.errors.fromDate, props.formikProps.touched.fromDate),
    errorMessage: checkInput(props.formikProps.errors.fromDate, props.formikProps.touched.fromDate) === _reactSharedUiNext.InputState.ERROR && props.formikProps.errors.fromDate
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6 col-sm-6 col-xs-12",
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.DatePicker, {
    disabled: props.orgProps.deviceDataProcceding,
    id: props.orgProps.dateTo.id,
    locale: "de",
    daysLongLocalized: _moment.default.weekdays(),
    daysShortLocalized: _moment.default.weekdaysMin(),
    monthsLocalized: _moment.default.months(),
    name: props.orgProps.dateTo.id,
    qaId: "qa-".concat(props.orgProps.dateTo.id),
    label: props.orgProps.dateTo.label,
    disabledDays: props.getMeterDateRange(),
    initialShownMonth: props.formikProps.values.toDate.date,
    showOverlay: props.orgState.dateToIsOpen && !props.orgProps.deviceDataProcceding,
    onBlur: function onBlur() {
      return props.handleBlur('to');
    },
    onFocus: function onFocus() {
      return props.setState({
        dateToIsOpen: true
      });
    },
    onClick: function onClick() {
      return props.setState({
        dateToIsOpen: true
      });
    },
    onChange: function onChange(date) {
      return props.handleChange(date, 'to', props.formikProps);
    },
    value: props.formikProps.values.toDate,
    useNative: props.orgProps.isMobile || props.orgProps.isTablet,
    inputState: checkInput(props.formikProps.errors.toDate, props.formikProps.touched.toDate),
    errorMessage: checkInput(props.formikProps.errors.toDate, props.formikProps.touched.toDate) === _reactSharedUiNext.InputState.ERROR && props.formikProps.errors.toDate
  })));
};
var getDefaultFromTo = function getDefaultFromTo(props, apiTo, apiFrom) {
  var nowObj = (0, _moment.default)();
  var apiToObj = !apiTo ? nowObj : (0, _moment.default)(fixMonth(apiTo));
  var toDate = apiToObj.valueOf() < nowObj.valueOf() ? apiToObj : nowObj.subtract(1, 'days');
  var fromDate = (0, _moment.default)(toDate).subtract(1, 'month');
  if (apiFrom) {
    var apiFromObj = (0, _moment.default)(fixMonth(apiFrom));
    if (fromDate.isBefore(apiFromObj)) {
      fromDate = apiFromObj;
    }
  }
  var isDevice = props && (props.isMobile || props.isTablet);
  return {
    fromDate: {
      text: !isDevice ? fromDate.format(_dateValidation.DATE_FORMAT) : fromDate.format(_dateValidation.DATE_FORMAT_NATIVE),
      date: fromDate.toDate(),
      start: fromDate.toDate(),
      api: fromDate.format(_dateValidation.DATE_FORMAT_NATIVE)
    },
    toDate: {
      text: !isDevice ? toDate.format(_dateValidation.DATE_FORMAT) : toDate.format(_dateValidation.DATE_FORMAT_NATIVE),
      date: toDate.toDate(),
      start: toDate.toDate(),
      api: toDate.format(_dateValidation.DATE_FORMAT_NATIVE)
    }
  };
};

/* eslint-enable react/prop-types */

/**
 * @module ContractNavigation
 */
var ReadingDateRange = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ReadingDateRange, _React$Component);
  var _super = _createSuper(ReadingDateRange);
  function ReadingDateRange() {
    var _this;
    (0, _classCallCheck2.default)(this, ReadingDateRange);
    _this = _super.call(this);
    _this.selectedDevice = {};
    _this.state = {
      dateFromIsOpen: false,
      dateToIsOpen: false,
      initialDate: false
    };
    return _this;
  }
  (0, _createClass2.default)(ReadingDateRange, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      _SessionHandler.default.userMustBeLoggedIn(_SessionHandler.loginTypes.loggedIn, _SessionHandler.loginTypes.callCenter);
      this.setState(getDefaultFromTo(this.props));
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;
      if (nextProps.devices && nextProps.selectedDeviceId) {
        this.selectedDevice = nextProps.devices.find(function (elem) {
          return _this2.props.getDeviceId(elem) === nextProps.selectedDeviceId;
        });
        var defaultDateForDevice = this.props.getBoundaries ? this.props.getBoundaries(getDefaultFromTo(this.props, this.props.getTo(this.selectedDevice), this.props.getFrom(this.selectedDevice)), this.selectedDevice) : getDefaultFromTo(this.props, this.props.getTo(this.selectedDevice), this.props.getFrom(this.selectedDevice));
        // device change
        if (this.props.selectedDeviceId !== nextProps.selectedDeviceId) {
          this.setState({
            initialDate: true
          });
          this.props.setSelectedDate(defaultDateForDevice.fromDate.api, defaultDateForDevice.toDate.api);
          if (this.formikState) {
            this.formikState.resetForm({
              values: _objectSpread({}, defaultDateForDevice)
            });
          }
          this.props.getDeviceData(this.selectedDevice, {
            selectedStartDate: defaultDateForDevice.fromDate.api,
            selectedEndDate: defaultDateForDevice.toDate.api
          });
        }

        // date change
        if (this.props.selectedStartDate !== nextProps.selectedStartDate || this.props.selectedEndDate !== nextProps.selectedEndDate || this.state.initialDate) {
          if (this.formikState && this.state.initialDate) {
            this.formikState.resetForm({
              values: _objectSpread({}, defaultDateForDevice)
            });
          }
          this.setState(function (prevState) {
            return {
              initialDate: false
            };
          });
          this.props.getDeviceData(this.selectedDevice, nextProps);
        }

        // device data change
        if (this.props.deviceData !== nextProps.deviceData) {
          this.props.setStartTime(createMeasurementsList(nextProps.deviceData));
        }
      }
    }
  }, {
    key: "getMeterDateRange",
    value: function getMeterDateRange() {
      var _this3 = this;
      var meterRanges;
      var ranges = this.selectedDevice.dateRanges;
      if (ranges && ranges.length > 1) {
        var results = [];
        meterRanges = ranges.map(function (item, index) {
          var dateRange = [];
          results.push(item);
          if (index === 0) {
            dateRange.push({
              before: formatDate(fixMonth(_this3.props.getFrom(_this3.selectedDevice))),
              after: _this3.getToDateLimit()
            });
          } else {
            dateRange.push(getDatesBetween(formatDate(fixMonth(results[index - 1].valid && results[index - 1].valid.to)), formatDate(fixMonth(results[index].valid && results[index].valid.from))));
          }
          return dateRange;
        });
      } else {
        meterRanges = {
          before: formatDate(fixMonth(this.props.getFrom(this.selectedDevice))),
          after: this.getToDateLimit()
        };
      }
      return Array.isArray(meterRanges) ? meterRanges.flat(Infinity) : meterRanges;
    }
  }, {
    key: "getToDateLimit",
    value: function getToDateLimit() {
      var invalidDate = (0, _moment.default)(formatDate(fixMonth(this.props.getTo(this.selectedDevice)))).toDate();
      return invalidDate * 1 > new Date() * 1 ? new Date() : invalidDate;
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(ref) {
      if (ref === 'from') {
        this.setState({
          dateFromIsOpen: false
        });
      } else {
        this.setState({
          dateToIsOpen: false
        });
      }
    }
  }, {
    key: "handleChange",
    value: function () {
      var _handleChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(dateObj, ref, formikBag) {
        var newDateObj;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                newDateObj = _objectSpread(_objectSpread({}, dateObj), {}, {
                  start: dateObj.date
                });
                this.setState({
                  initialDate: false
                });
                if (!(ref === 'from')) {
                  _context.next = 12;
                  break;
                }
                formikBag.setFieldValue('fromDate', newDateObj);
                formikBag.setFieldTouched('fromDate');
                this.setState({
                  initialDate: false
                });
                _context.next = 8;
                return Promise.resolve();
              case 8:
                formikBag.submitForm();
                this.setState({
                  dateFromIsOpen: false
                });
                _context.next = 19;
                break;
              case 12:
                formikBag.setFieldValue('toDate', newDateObj);
                formikBag.setFieldTouched('toDate');
                this.setState({
                  initialDate: false
                });
                _context.next = 17;
                return Promise.resolve();
              case 17:
                formikBag.submitForm();
                this.setState({
                  dateToIsOpen: false
                });
              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function handleChange(_x, _x2, _x3) {
        return _handleChange.apply(this, arguments);
      }
      return handleChange;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      if (this.props.devices && this.props.selectedDeviceId) {
        this.selectedDevice = this.props.devices.find(function (elem) {
          return _this4.props.getDeviceId(elem) === _this4.props.selectedDeviceId;
        });
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(BASE_CLASS)
      }, this.selectedDevice && this.props.getFrom(this.selectedDevice) ? /*#__PURE__*/_react.default.createElement(_formik.Formik, {
        initialValues: {
          fromDate: this.state.fromDate,
          toDate: this.state.toDate
        },
        validate: function validate(values) {
          var errors = {};
          var meterRange = _this4.getMeterDateRange();
          var meterDateRangeMin = meterRange.length ? meterRange[0].before : meterRange.before;
          var meterDateRangeMax = meterRange.length ? meterRange[0].after : meterRange.after;
          // errors for fromDate field
          if (!(0, _dateValidation.dateFormatValid)(values.fromDate.text, _this4.props)) {
            // is date format valid
            errors.fromDate = _this4.props.errorMessages.general;
          } else if ((0, _dateValidation.isDateBefore)(values.fromDate.date, meterDateRangeMin)) {
            // is entered date before validFrom
            errors.fromDate = replaceStringPlaceholder(_this4.props.errorMessages.fromDateNotInRange, [(0, _moment.default)(formatDate(fixMonth(_this4.props.getFrom(_this4.selectedDevice)))).subtract(1, 'days').format(_dateValidation.DATE_FORMAT)]);
          } else if ((0, _dateValidation.isDateAfter)(values.fromDate.date, meterDateRangeMax)) {
            // is entered date after today
            errors.fromDate = replaceStringPlaceholder(_this4.props.errorMessages.toDateNotInRange, [(0, _moment.default)(_this4.getToDateLimit()).add(1, 'days').format(_dateValidation.DATE_FORMAT)]);
          } else if ((0, _dateValidation.dateFormatValid)(values.fromDate.text, _this4.props) && (0, _dateValidation.dateFormatValid)(values.toDate.text, _this4.props) && (0, _dateValidation.isDateAfter)(values.fromDate.date, values.toDate.date)) {
            // is fromDate after toDate
            errors.fromDate = _this4.props.errorMessages.dateBackwardsInTime;
          }

          // errors for toDate
          if (!(0, _dateValidation.dateFormatValid)(values.toDate.text, _this4.props)) {
            // is date format valid
            errors.toDate = _this4.props.errorMessages.general;
          } else if ((0, _dateValidation.isDateBefore)(values.toDate.date, meterDateRangeMin)) {
            // is entered date before validFrom
            errors.toDate = replaceStringPlaceholder(_this4.props.errorMessages.fromDateNotInRange, [(0, _moment.default)(formatDate(fixMonth(_this4.props.getFrom(_this4.selectedDevice)))).subtract(1, 'days').format(_dateValidation.DATE_FORMAT)]);
          } else if ((0, _dateValidation.isDateAfter)(values.toDate.date, meterDateRangeMax)) {
            // is entered date after today
            errors.toDate = replaceStringPlaceholder(_this4.props.errorMessages.toDateNotInRange, [(0, _moment.default)(_this4.getToDateLimit()).add(1, 'days').format(_dateValidation.DATE_FORMAT)]);
          } else if ((0, _dateValidation.dateFormatValid)(values.fromDate.text, _this4.props) && (0, _dateValidation.dateFormatValid)(values.toDate.text, _this4.props) && (0, _dateValidation.isDateBefore)(values.toDate.date, values.fromDate.date)) {
            // is fromDate after toDate
            errors.toDate = _this4.props.errorMessages.dateBackwardsInTime;
          }
          if (_this4.props.oneYearLimit && (0, _dateValidation.dateFormatValid)(values.fromDate.text, _this4.props) && (0, _dateValidation.dateFormatValid)(values.toDate.text, _this4.props) && (0, _dateValidation.isDateRangeGreaterThenThreshold)(values.fromDate.date, values.toDate.date)) {
            // is date range selected larger then allowed (1 year)
            errors.fromDate = _this4.props.errorMessages.dateRangeBiggerThenAllowed;
            errors.toDate = _this4.props.errorMessages.dateRangeBiggerThenAllowed;
          }
          return errors;
        },
        onSubmit: function onSubmit(values) {
          _this4.props.setSelectedDate((0, _moment.default)(values.fromDate.date).format(_dateValidation.DATE_FORMAT_NATIVE), (0, _moment.default)(values.toDate.date).format(_dateValidation.DATE_FORMAT_NATIVE));
        },
        render: function render(formikProps) {
          _this4.formikState = formikProps;
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "row consumption-visualization-date-range"
          }, /*#__PURE__*/_react.default.createElement(DateRangeForm, {
            formikProps: formikProps,
            orgProps: _this4.props,
            orgState: _this4.state,
            setState: function setState(obj) {
              return _this4.setState(obj);
            },
            getMeterDateRange: function getMeterDateRange() {
              return _this4.getMeterDateRange();
            },
            handleBlur: function handleBlur(e) {
              return _this4.handleBlur(e);
            },
            handleChange: function handleChange(dateObj, ref, formikBag) {
              return _this4.handleChange(dateObj, ref, formikBag);
            }
          }));
        }
      }) : /*#__PURE__*/_react.default.createElement("div", {
        className: "contract-navigation-loader-wrapper form-wrapper form-wrapper--has-shadow"
      }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Loader, {
        loading: !this.selectedDevice,
        fallbackGifSrc: sessionStorage.fallbackLoader
      })));
    }
  }]);
  return ReadingDateRange;
}(_react.default.Component);
ReadingDateRange.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  devices: _propTypes.default.array,
  deviceData: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array]),
  selectedDeviceId: _propTypes.default.string,
  selectedStartDate: _propTypes.default.string,
  selectedEndDate: _propTypes.default.string,
  setSelectedDate: _propTypes.default.func,
  setStartTime: _propTypes.default.func,
  getDeviceData: _propTypes.default.func,
  errorMessages: _propTypes.default.shape({
    general: _propTypes.default.string,
    fromDateNotInRange: _propTypes.default.string,
    toDateNotInRange: _propTypes.default.string,
    dateBackwardsInTime: _propTypes.default.string,
    dateRangeBiggerThenAllowed: _propTypes.default.string
  }),
  getDeviceId: _propTypes.default.func,
  // eslint-disable-next-line react/no-unused-prop-types
  dateFrom: _propTypes.default.shape({
    label: _propTypes.default.string,
    id: _propTypes.default.string
  }).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  dateTo: _propTypes.default.shape({
    label: _propTypes.default.string,
    id: _propTypes.default.string
  }).isRequired,
  getFrom: _propTypes.default.func,
  getTo: _propTypes.default.func,
  oneYearLimit: _propTypes.default.bool,
  getBoundaries: _propTypes.default.func
};
var _default = exports.default = (0, _reactSharedUiNext.WithEnvInformation)({
  getBrowserInfo: true,
  getDeviceInfo: true
})(ReadingDateRange);